import { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSponsoredProducts } from '../../../../../appState/ducks/listingPageProducts';
import sponsoredProductsPropType from './sponsoredProductsPropType';

const nop = () => {};

class SponsoredProductsResource extends PureComponent {
  componentDidMount() {
    this.props.getSponsoredProducts(this.props.segmentId);
  }

  componentDidUpdate(prevProps) {
    const { sponsoredProducts, onLoaded } = this.props;
    if (sponsoredProducts !== prevProps.sponsoredProducts) {
      onLoaded(sponsoredProducts);
    }
  }

  render() {
    const { sponsoredProducts, children, loadBeaconUrl } = this.props;
    return children(sponsoredProducts || [], loadBeaconUrl);
  }
}

SponsoredProductsResource.displayName = 'SponsoredProductsResource';

SponsoredProductsResource.propTypes = {
  segmentId: PropTypes.number.isRequired,
  loadBeaconUrl: PropTypes.string,
  sponsoredProducts: sponsoredProductsPropType,
  children: PropTypes.func,
  getSponsoredProducts: PropTypes.func,
  onLoaded: PropTypes.func
};

SponsoredProductsResource.defaultProps = {
  loadBeaconUrl: null,
  sponsoredProducts: [],
  children: nop,
  getSponsoredProducts: nop,
  onLoaded: nop
};

function mapStateToProps({ listingPage }) {
  const sponsoredProducts = listingPage.products.sponsoredProducts;
  return {
    loadBeaconUrl: sponsoredProducts && sponsoredProducts.onLoadBeacon,
    sponsoredProducts: sponsoredProducts ? sponsoredProducts.items : []
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getSponsoredProducts
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SponsoredProductsResource);
